/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { convertKeysToSnakeCase, empty, errorResponse, getInputDateFormat, isArray, isNull, isString, isUndefined, prepareResponseData } from "../../Utilities/utils";
import { Toast } from "primereact/toast";

// css
import "../students/Students.css";

// api
import activityApi from "../../api/Activities";
import studentApi from "../../api/Student";
import classApi from "../../api/Classes";
import staffApi from "../../api/Staff";
import parentsApi from "../../api/Parents";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import FullPageLoader from "../../components/loader/FullPageLoader";
import InputField from "../../components/form/InputField";
import { AuthContext } from "../Root/ProtectedRoute";
import ActivitiesWrapper from "../../components/appWrapper/ActivitiesWrapper";
import SelectField from "../../components/form/SelectField";
import { Editor } from "primereact/editor";
import Header4 from "../../components/headers/Header4";
import colors from "../../config/colors";
import { participantTypes, reoccuringFrequency } from "../../data/ParticipantTypes";
import MultiSelectField from "../../components/form/MultiSelectField";
import { activityStatus } from "../../data/ActivityNature";
import { yesNo } from "../../data/yesNo";
import { DaysOfTheWeek } from "../../data/DaysOfTheWeek";
import InputFieldChange from "../../components/form/InputFieldChange";

const required = "This field is required!";
const validationSchema = Yup.object().shape({
  title: Yup.string().required(required),
  type: Yup.string().required(required),
  participant_types: Yup.array().required(required),
  class_ids: Yup.array().optional(),
  student_ids: Yup.array().optional(),
  staff_ids: Yup.array().optional(),
  parent_ids: Yup.array().optional(),
  start_date: Yup.string().required(required),
  end_date: Yup.string().required(required),
  location: Yup.string().required(required),
  status: Yup.string().required(required),
  visible: Yup.string().required(required),
  payment_required: Yup.string().required(required),
  max_participants: Yup.number().required(required),
  cost: Yup.number().optional(),
  payment_deadline: Yup.string().optional(),
  is_recurring: Yup.string().required(required),
  days: Yup.array().optional(),
  start_time: Yup.string().required(required),
  end_time: Yup.string().required(required),
  recuring_frequency: Yup.string().optional(),
  days_time: Yup.array().of(
    Yup.object().shape({})
  ),
});

const AddUpdateActivity = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const [initialValues, setInitialValues] = useState({
    title: "",
    participant_types: [],
    is_recurring: '',
    type: '',
    class_ids: [],
    student_ids: [],
    staff_ids: [],
    parent_ids: [],
    start_date: '',
    end_date: '',
    location: '',
    status: '',
    visible: '',
    payment_required: '',
    max_participants: 0,
    cost: 0,
    payment_deadline: '',
    days: [],
    days_time: DaysOfTheWeek?.map(day => (
      {
        day: day?.value || '', 
        start_time: '',
        end_time: '', 
        start_date: '',
        end_date: ''
      }
    )) || [],
    re_curing_frequency: ''
  });
  const [students, setStudents] = useState([]);
  const [parents, setParents] = useState([]);
  const [staff, setStaff] = useState([]);
  const [classes, setClasses] = useState([]);
  const [activityTypes, setActivityTypes] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { activityId } = useParams();
  const toastTR = useRef(null);
  const [ activityDescription, setActivityDescription ] = useState('');
  const [requirementDescription, setRequirementDescription] = useState('');

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    getActivityTypes();
  }, []);

  useEffect(() => {
    if (activityId) {
      getActivity();
    }
  }, []);

  /**
   * Get activity types
   * @returns 
   */
  const getActivityTypes = async () => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await activityApi.getActivityTypes(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setActivityTypes([]);
      } else {
        setActivityTypes(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    }
  };

  /**
   * Get All Stuents
   * @returns 
   */
  const getAllStudents = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.getStudents(schoolId, 0, 2000);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setStudents([]);
      } else {
        setStudents(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get Parents
   * @returns 
   */
  const getParents = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await parentsApi.getParents(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setParents([]);
      } else {
        setParents(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get All Class
   * @returns 
   */
  const getClasses = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const response = await classApi.getClasses('yes');
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setClasses([]);
      } else {
        setClasses(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };


  /**
   * Get All Staff
   * @returns 
   */
  const getAllStaff = async () => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await staffApi.getStaff(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setStaff([]);
      } else {
        setStaff(response_data?.response || []);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get activity details
   * @returns 
   */
  const getActivity = async () => {
    setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await activityApi.getActivityDetails(schoolId, activityId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Failed to get class details."
        );
      }

      if (!empty(response_data) && !empty(response_data.response)) {
        const data = response_data.response;
        delete data.dateCreated;
        delete data.creator;

        // convert fields to camel case 
        const values = convertKeysToSnakeCase(data);
        delete values.id;
        delete values.school_id;
        setActivityDescription(values?.activity_description || '');
        setRequirementDescription(values?.requirement_description || '');

        delete values.activity_description;
        delete values.requirement_description;

        if (!empty(values?.class_ids)) {
          await getClasses();
        }

        if (!empty(values?.student_ids)) {
          await getAllStudents();
        }

        if (!empty(values?.staff_ids)) {
          await getAllStaff();
        }

        if (!empty(values?.parent_ids)) {
          await getParents();
        }

        values.visible = values?.visible === true ? 'Yes' : 'No';
        if (!empty(values?.payment_deadline)) {
          values.payment_deadline = getInputDateFormat(new Date(values?.payment_deadline || ''));
        }
        if (!empty(values?.start_date)) {
          values.start_date = getInputDateFormat(new Date(values?.start_date || ''));
        }
        if (!empty(values?.end_date)) {
          values.end_date = getInputDateFormat(new Date(values?.end_date || ''));
        }

        return setInitialValues((prev) => ({ ...prev, participant_types: [], class_ids: [], student_ids: [], parent_ids: [], days: [], ...values }));
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Handle submission
   * @param values
   */
  const handleSubmit = async (values) => {
    if (!isLoading) setIsLoading(true);
    try {
      if (empty(values)) {
        return responseDialog(
          "error",
          "Error Alert",
          "Something went wrong! Try again later."
        );
      }

      if (values?.participant_types === 'Class' && empty(values?.class_ids)) {
        return responseDialog(
          "error",
          "The 'Class' field is required",
          "Please select at least one class."
        );
      }
      if (values?.participant_types === 'Staff' && empty(values?.staff_ids)) {
        return responseDialog(
          "error",
          "The 'Staff' field is required",
          "Please select at least one staff."
        );
      }
      if (values?.participant_types === 'Parents' && empty(values?.parent_ids)) {
        return responseDialog(
          "error",
          "The 'Parent' field is required",
          "Please select at least one staff."
        );
      }
      if (values?.participant_types === 'Students' && empty(values?.student_ids)) {
        return responseDialog(
          "error",
          "The 'Student' field is required",
          "Please select at least one student."
        );
      }
      // validate registration payment
      if (values?.payment_required?.toLowerCase() === 'yes') {
        if (empty(values?.payment_deadline)) {
          return responseDialog(
            "error",
            "The 'Payment Deadline' field is required",
            "Please enter a value."
          );
        }
        if (empty(values?.max_participants)) {
          return responseDialog(
            "error",
            "The 'Max. Participants' field is required",
            "Please enter a value."
          );
        }
        if (empty(values?.cost)) {
          return responseDialog(
            "error",
            "The 'Cost' field is required",
            "Please enter a value."
          );
        }
      }
      // re-occuring validations
      if (values?.is_recurring?.toLowerCase() === 'yes') {
        if (empty(values?.recuring_frequency)) {
          return responseDialog(
            "error",
            "The 'Recuring Frequency' field is required",
            "Please enter a value."
          );
        }
        if (empty(values?.days)) {
          return responseDialog(
            "error",
            "The 'Days' field is required",
            "Please enter a value."
          );
        }
      }

      const days_times = values?.days_time || [];
      if (isArray(days_times)) {
        days_times.forEach((item, index) => {
          const day = item?.day || '';
          if ((!empty(day) && empty(item?.start_date) && empty(item?.end_date) && empty(item?.start_time) && empty(item?.end_time) && !values?.days?.includes(day)) || isNull(item) || isUndefined(item)) {
            days_times.splice(index, 1);
          }
        })
      }
      if (empty(activityDescription)) {
        return responseDialog(
          "error",
          "Activity Description is required.",
          "Please add some details for this activity item."
        );
      }
      values.days_time = days_times; 
      values.activity_description = activityDescription; 
      values.requirement_description = requirementDescription; 
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";

      let response;
      let activityAdded = false;
      let activityUpdated = false;
      if (!activityId) {
        response = await activityApi.addActivity(schoolId, values);
        activityAdded = true;
      } else {
        response = await activityApi.updateActivity(
          schoolId,
          activityId,
          values
        );
        activityUpdated = true;
      }
      const response_data = prepareResponseData(response);
      if (!response_data?.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!"
        );
      }

      navigate("/list-activities", {
        state: { activityAdded, activityUpdated },
      });
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  // handle input type
  const handleInputType = (name, setFieldValue, type, field, day, values) => async (e) => {
    const value =
      !empty(e) &&
      !empty(e.target) &&
      !empty(e.target.value) &&
      isString(e.target.value)
        ? e.target.value
        : "";
    setFieldValue(name, value);

    if (type === 'day_time') {
      const daysTime = values?.days_time || [];
      let found = false;
      if (isArray(daysTime)) {
        for (let i = 0; i < daysTime.length; i++) {
          const dayTime = daysTime?.[i] || {};
          if (!empty(dayTime)) {
            const _day = dayTime?.day || '';
            if (!empty(_day) && _day === day && values?.days?.includes(day)) {
              dayTime[field] = value;
              found = true;
              break;
            }
          }
        }

        if (!found) {
          daysTime.push({ day, [field]: value });
          setFieldValue('days_time', daysTime);
        }
      }
    }
  };

  const handleMultiSelectChange = async (name, newValue, setFieldValue, values) => {
    const inputValues = !empty(newValue) && isArray(newValue) ? newValue : [];
    setFieldValue(name, inputValues);
    if (name === 'days') {
      const daysTime = isArray(values.days_time) ? values.days_time : [];
      const newDaysTime = [];
      await daysTime?.forEach(item => {
        const day = item?.day || '';
        if (values?.days?.includes(day)) {
          newDaysTime.push(item);
        }
      });
      
      if (!empty(newDaysTime) && isArray(newDaysTime)) {
        setFieldValue('days_time', newDaysTime);
      }
    }

    if (inputValues.includes('Students')) {
      if (empty(students)) {
        return await getAllStudents();
      }
    }

    if (inputValues.includes('Class')) {
      if (empty(classes)) {
        return await getClasses();
      }
    }

    if (inputValues.includes('Staff')) {
      if (empty(staff)) {
        return await getAllStaff();
      }
    }

    if (inputValues.includes('Parents')) {
      if (empty(parents)) {
        return await getParents();
      }
    }
  }

  return (
    <>
      <ActivitiesWrapper {...props}>
        <main>
          <div className="container flex-center-top">
            <MainHeader
              title={
                !empty(activityId)
                  ? "Update Activity"
                  : "Add Activity"
              }
            />
            <div className="form-container mt-30">
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
              {({ values, setFieldValue }) => (
                <Form style={{ width: "100%" }}>
                  <div className="app_input_group">
                    <InputField
                      placeholder="Enter Activity Type Title E.g Inter-house sports, Exam etc"
                      name="title"
                      height={50}
                      labelTitle="Title"
                      required={true}
                    />
                    <SelectField
                      labelTitle="Activity Type"
                      required={true}
                      placeholder="Select Activity Type"
                      name="type"
                      options={activityTypes}
                      height={50}
                      valueKey="id"
                      selectedOption={values.type}
                      handleChangeFunc={handleInputType(
                        "type",
                        setFieldValue
                      )}
                    />
                  </div>
                  <Header4>
                    <span className="fs-16">
                      Description <span className="required">*</span>
                    </span>
                  </Header4>
                  <div style={{ width: '100%' }}>
                    <Editor value={activityDescription} onTextChange={(e) => setActivityDescription(e.htmlValue)} style={{ height: '320px', backgroundColor: colors.white }} />
                  </div>
                  <div className="app_input_group mb-40">
                    <MultiSelectField
                      labelTitle="Participant Type(s)"
                      placeholder="Select Participant Type(s)"
                      name="participant_types"
                      options={participantTypes || []}
                      selectedOptions={values.participant_types || []}
                      optionValue="title"
                      required={true}
                      height={50}
                      mt="mt-10"
                      onChange={(e) =>
                        handleMultiSelectChange(
                          "participant_types",
                          e.value,
                          setFieldValue
                        )
                      }
                    />
                  </div>
                    {!empty(values?.participant_types) &&
                    <div className="app_input_group mb-40">
                      {values?.participant_types.includes("Class") && (
                        <MultiSelectField
                          labelTitle="Class(es)"
                          placeholder="Select Class(es)"
                          name="class_ids"
                          options={classes || []}
                          selectedOptions={values.class_ids || []}
                          valueKey="_id"
                          required={true}
                          height={50}
                          mt="mt-10"
                          onChange={(e) =>
                            handleMultiSelectChange(
                              "class_ids",
                              e.value,
                              setFieldValue
                            )
                          }
                          />
                      )}
                      { values?.participant_types.includes('Students') && 
                        <MultiSelectField
                          labelTitle="Student(s)"
                          placeholder="Select Student(s)"
                          name="student_ids"
                          options={students || []}
                          selectedOptions={values.student_ids || []}
                          valueKey="_id"
                          required={true}
                          height={50}
                          optionLabel="fullNameClassTitle"
                          mt="mt-10"
                          onChange={(e) =>
                            handleMultiSelectChange(
                              "student_ids",
                              e.value,
                              setFieldValue
                            )
                          }
                          />
                      }
                      { values?.participant_types.includes('Staff') && 
                        <MultiSelectField
                          labelTitle="Staff"
                          placeholder="Select Staff"
                          name="staff_ids"
                          options={staff || []}
                          selectedOptions={values.staff_ids || []}
                          valueKey="_id"
                          required={true}
                          height={50}
                          optionLabel="fullName"
                          mt="mt-10"
                          onChange={(e) =>
                            handleMultiSelectChange(
                              "staff_ids",
                              e.value,
                              setFieldValue
                            )
                          }
                          />
                      }
                      { values?.participant_types.includes('Parents') && 
                        <MultiSelectField
                          labelTitle="Parent(s)"
                          placeholder="Select Parent(s)"
                          name="parent_ids"
                          options={parents || []}
                          selectedOptions={values.parent_ids || []}
                          valueKey="_id"
                          required={true}
                          height={50}
                          mt="mt-10"
                          optionLabel="fullName"
                          onChange={(e) =>
                            handleMultiSelectChange(
                              "parent_ids",
                              e.value,
                              setFieldValue
                            )
                          }
                        />
                      }
                    </div>
                  }
                  <div className="app_input_group">
                    <InputField
                      placeholder="Enter Start Date"
                      name="start_date"
                      height={50}
                      labelTitle="Start Date"
                      required={true}
                      type='date'
                    />
                    <InputField
                      placeholder="Enter End Date"
                      name="end_date"
                      height={50}
                      labelTitle="End Date"
                      required={true}
                      type='date'
                    />
                  </div>
                  <div className="app_input_group">
                    <InputField
                      placeholder="Enter Location"
                      name="location"
                      height={50}
                      labelTitle="Location"
                      required={true}
                    />
                  </div>
                  <div className="app_input_group">
                    <SelectField
                      labelTitle="Status"
                      required={true}
                      placeholder="Select Status"
                      name="status"
                      options={activityStatus}
                      height={50}
                      valueKey="title"
                      containerWidth={300}
                      selectedOption={values.status}
                      handleChangeFunc={handleInputType(
                        "status",
                        setFieldValue
                      )}
                      />
                  </div>
                  <div className="app_input_group mb-40">
                    <SelectField
                      labelTitle="Visible?"
                      required={true}
                      placeholder="Select Option"
                      name="visible"
                      options={yesNo}
                      height={50}
                      valueKey="title"
                      containerWidth={300}
                      selectedOption={values.visible}
                      handleChangeFunc={handleInputType(
                        "visible",
                        setFieldValue
                      )}
                    />
                  </div>
                  <Header4>
                    <span className="fs-16" style={{ color: colors.darkSecondary}}>
                      <strong>Registration</strong>
                    </span>
                  </Header4>
                  <div className="app_input_group mb-20">
                    <SelectField
                      labelTitle="Payment Required?"
                      required={true}
                      placeholder="Select Option"
                      name="payment_required"
                      options={yesNo}
                      height={50}
                      valueKey="title"
                      containerWidth={250}
                      selectedOption={values.payment_required}
                      handleChangeFunc={handleInputType(
                        "payment_required",
                        setFieldValue
                      )}
                    />
                    {values?.payment_required?.toLowerCase() === 'yes' && 
                      <>
                        <InputField
                          placeholder="Enter Cost"
                          name="cost"
                          height={50}
                          labelTitle="Cost"
                          required={true}
                          containerWidth={250}
                          icon="pi pi-money-bill"
                        />
                        <InputField
                          placeholder="Enter Payment Deadline"
                          name="payment_deadline"
                          height={50}
                          labelTitle="Payment Deadline"
                          required={true}
                          containerWidth={250}
                          type='date'
                        />
                      </>
                      }
                      
                      <InputField
                        placeholder="Enter Max. Participants"
                        name="max_participants"
                        height={50}
                        labelTitle="Max. Participents"
                        required={true}
                        containerWidth={250}
                        type='number'
                      />
                  </div>
                  <Header4>
                    <span className="fs-16">
                      Requirement Description
                    </span>
                  </Header4>
                  <div style={{ width: '100%' }}>
                    <Editor value={requirementDescription} onTextChange={(e) => setRequirementDescription(e.htmlValue)} style={{ height: '320px', backgroundColor: colors.white }} />
                    </div>
                    
                    <div className="app_input_group mt-20">
                      <InputField
                        placeholder="Enter Start Time"
                        name="start_time"
                        height={50}
                        labelTitle="Start Time"
                        required={true}
                        containerWidth={250}
                        type='time'
                      />
                      <InputField
                        placeholder="Enter End Time"
                        name="end_time"
                        height={50}
                        labelTitle="End Time"
                        required={true}
                        containerWidth={250}
                        type='time'
                      />
                    </div>
                    
                  <div className="app_input_group">
                    <SelectField
                      labelTitle="Is Recurring?"
                      required={true}
                      placeholder="Select Option"
                      name="is_recurring"
                      options={yesNo}
                      height={50}
                      valueKey="title"
                      containerWidth={300}
                      selectedOption={values.is_recurring || ''}
                      handleChangeFunc={handleInputType(
                        "is_recurring",
                        setFieldValue
                      )}
                    />
                  </div>
                    
                    {values?.is_recurring?.toLowerCase() === 'yes' &&
                      <>
                        <div className="app_input_group">
                          <SelectField
                            labelTitle="Recurring Frequency"
                            required={true}
                            placeholder="Select Option"
                            name="recuring_frequency"
                            options={reoccuringFrequency}
                            height={50}
                            valueKey="title"
                            containerWidth={300}
                            selectedOption={values.recuring_frequency}
                            handleChangeFunc={handleInputType(
                              "recuring_frequency",
                              setFieldValue
                            )}
                          />
                        </div>
                        <div className="app_input_group">
                          <MultiSelectField
                            labelTitle="Day(s)"
                            placeholder="Select Day(s)"
                            name="days"
                            options={DaysOfTheWeek || []}
                            selectedOptions={values.days || []}
                            optionValue = "value"
                            required={true}
                            height={50}
                            mt="mt-10"
                            optionLabel="value"
                            onChange={(e) =>
                              handleMultiSelectChange(
                                "days",
                                e.value,
                                setFieldValue,
                                values
                              )
                            }
                          />
                        </div>
                      </>
                    }
                  
                    { !empty(values?.days) && <div className="app_input_group mt-20" style={{ flexWrap: 'wrap', padding: 15, border: `1px dotted ${colors.primary}` }}>
                    {
                      values?.days?.map((day, index) => {
                        return (
                          <div key={index} className="mb-20" style={{ width: '100%' }}>
                            <strong>{day}</strong>
                            <div className="app_input_group">
                              <InputFieldChange
                                placeholder="Enter Start Date"
                                name={`days_time[${index}].start_date`}
                                height={50}
                                labelTitle="Start Date"
                                type='date'
                                value={
                                  values.days_time?.[index]?.start_date || ""
                                }
                                onChange={handleInputType(
                                  `days_time[${index}].start_date`,
                                  setFieldValue, 
                                  'day_time',
                                  'start_date',
                                  day,
                                  values
                                )}
                              />
                              <InputFieldChange
                                height={50}
                                placeholder="Enter End Date"
                                name={`days_time[${index}].end_date`}
                                labelTitle="End Date"
                                type='date'
                                value={
                                  values.days_time?.[index]?.end_date || ""
                                }
                                onChange={handleInputType(
                                  `days_time[${index}].end_date`,
                                  setFieldValue, 
                                  'day_time',
                                  'end_date',
                                  day,
                                  values
                                )}
                              />
                              <InputFieldChange
                                height={50}
                                placeholder="Enter Start Time"
                                name={`days_time[${index}].start_time`}
                                labelTitle="Start Time"
                                type='time'
                                value={
                                  values.days_time?.[index]?.start_time || ""
                                }
                                onChange={handleInputType(
                                  `days_time[${index}].start_time`,
                                  setFieldValue, 
                                  'day_time',
                                  'start_time',
                                  day,
                                  values
                                )}
                              />
                              <InputFieldChange
                                height={50}
                                placeholder="Enter End Time"
                                name={`days_time[${index}].end_time`}
                                labelTitle="End Time"
                                type='time'
                                value={
                                  values.days_time?.[index]?.end_time || ""
                                }
                                onChange={handleInputType(
                                  `days_time[${index}].end_time`,
                                  setFieldValue, 
                                  'day_time',
                                  'end_time',
                                  day,
                                  values
                                )}
                              />
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>}
                  
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <ButtonIcon
                      height={45}
                      marginTop={5}
                      color="#ffffff"
                      backgroundColor="#633ccd"
                      width={300}
                      borderColor="#633ccd"
                      buttonText={
                        activityId ? "Update Activity" : "Add Activity"
                      }
                      type="submit"
                    />
                  </div>
                </Form>
              )}
              </Formik>
            </div>
          </div>
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
        <Toast ref={toastTR} position="bottom-left" />
      </ActivitiesWrapper>
    </>
  );
};

export default AddUpdateActivity;
